export const defaultValues = {
  alignerPrice: {adult: null},
  alignerSupplier: {enabled: false, name: []},
  avgAppointmentDelay: null,
  ceramicCrownPrice: {min: null, max: null},
  cerecCFAO: false,
  firstName: '',
  gender: null,
  implantPrice: {min: null, max: null},
  implantSupplier: {enabled: false, name: []},
  lastName: '',
  opticalImpression: false,
  orthoLabSupplier: {enabled: false, name: []},
  orthoPrice: {child: null, adult: null},
  prosthesisSupplier: {enabled: false, name: []},
  specialties: {
    omniPractice: false,
    implantology: false,
    orthodontics: false,
    periodontology: false,
    endodontics: false,
    other: []
  }
};
